import { Divider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as BriefcaseCheckIcon } from '../../../../../../assets/icons/layout-icons/BriefcaseCheckIcon.svg';
import CustomModal from '../../../../../../components/modal/CustomModal';
import { secondaryBlue } from '../../../../../../utils/color';
import CustomButton from '../../../../../../components/button/CustomButton';
import LinkedInLoginButton from '../../../../../../components/button/LinkedInLoginButton';

export interface ReviewModalProps {
  open: boolean;
  handleConfirm: () => void;
  handleCancel: () => void;
  isLoading?: boolean;
  handleLinkedIn: () => void;
}

const ReviewModal = ({
  open,
  handleConfirm,
  handleCancel,
  isLoading,
  handleLinkedIn,
}: ReviewModalProps) => {
  const { t } = useTranslation();
  return (
    <CustomModal open={open} sx={{ width: '100%', maxWidth: '600px' }}>
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center">
          <Stack
            width={40}
            height={40}
            mr={2}
            bgcolor="secondaryBlue.100"
            borderRadius={1}
            justifyContent="center"
            alignItems="center"
          >
            <BriefcaseCheckIcon width="20px" fill={secondaryBlue[700]} height="20px" />
          </Stack>
          <Typography variant="heading5">
            {t('caseStudies.modals.csReviewerIdentification.title')}
          </Typography>
          {/* <Typography variant="heading5">schedule call</Typography> */}
        </Stack>
        <Divider />
        <Stack spacing={6} pb={2}>
          <Typography pt={1} pb={1} variant="body3" color="primaryDark.500">
            {t('caseStudies.modals.csReviewerIdentification.description')}
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
            spacing={2}
          >
            <CustomButton sx={{ width: 'fit-content' }} loading={isLoading} onClick={handleConfirm}>
              {t('caseStudies.modals.csReviewerIdentification.scheduleCall')}
            </CustomButton>
            <Divider orientation="vertical" flexItem>
              {' '}
              <Typography sx={{ pb: '4px' }}>{t('common.or')}</Typography>{' '}
            </Divider>

            <LinkedInLoginButton loading={isLoading} onClick={handleLinkedIn}>
              {t('caseStudies.modals.csReviewerIdentification.logInLinkedIn')}
            </LinkedInLoginButton>
          </Stack>
        </Stack>
        <Divider />
        <Stack direction="row" sx={{ justifyContent: 'right' }} spacing={2}>
          <CustomButton loading={isLoading} variant="primaryLight" onClick={handleCancel}>
            {t('common.cancel')}
          </CustomButton>
        </Stack>
      </Stack>
    </CustomModal>
  );
};

export default ReviewModal;
